import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  StyledLoggedOutPage,
  StyledForm,
  StyledTextInput,
  StyledSubmitBtn,
  StyledLogoWrapper,
  StyledLogo,
  StyledHeader,
  StyledSuccessText,
  StyledLoggedOutPageContentWrapper,
  StyledPageImage
} from '../styled-components/StyledLoggedOutPage';
import Alert from '../styled-components/StyledAlerts';

const StyledParagraph = styled.p`
  margin-bottom: 2rem;
`;


class ForgotCodeForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
    };
  }

  _submitForm = (e) => {
    e.preventDefault();
    this.props.submitCallback(this.state.email);
  }

  render() {
    return (
      <StyledLoggedOutPage>
        <StyledLoggedOutPageContentWrapper>
          <StyledForm onSubmit={this._submitForm}>
            <StyledLogoWrapper>
              <StyledLogo />
            </StyledLogoWrapper>
            {this.props.sent && <Alert icon="check-circle" type="success"><p>If a matching account was found an email has been sent with your login code.</p></Alert>}
            <StyledHeader>Forgot Code?</StyledHeader>
            <StyledParagraph>
              Please enter your email address below and we'll send you an email with your login code included.
            </StyledParagraph>
            <StyledTextInput
              required
              label="Email"
              name="email"
              id="email"
              type="email"
              onChange={event => this.setState({ email: event.target.value })}
              placeholder="Email Address"
              value={this.state.email}
            />
            <StyledSubmitBtn loading={this.props.sending}>Send Email</StyledSubmitBtn>
          </StyledForm>
        </StyledLoggedOutPageContentWrapper>
        {/* <StyledPageImage /> */}
      </StyledLoggedOutPage>
    );
  }
}

ForgotCodeForm.propTypes = {
  submitCallback: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired,
  sent: PropTypes.bool.isRequired,
};

export default ForgotCodeForm;